<template>
  <div class="rollbox-component">
    <div class="rollbox-line">
      <div class="rollbox-number">
        <div :key="index" class="number-list-wrapper" v-for="(item, index) in [1,2]">
          <ul :ref="`reel${index}`" class="number-list">
            <li :key="i" class="number-item" v-for="(number, i) in numbers">{{number}}</li>
          </ul>
        </div>
      </div>
      <div class="rollbox-percent">%</div>
    </div>
    <div class="rollbox-off">{{offText}}</div>
  </div>
</template>
<script>
  import { timeout } from '@/utils/assist'
  // 完全平移掉一个数字的距离(%)
  // 这个数值是固定的 100 / numbers.length
  // 确保是一个整数
  const deltPercent = 5

  // 每次平移距离(%)
  const delt = [-2, -2]
  /**
   * 和延迟相关的一系列设置
   */
  // 减速间隔
  const duration1 = 20
  // 最后停下来时所需的时长 需要和CSS配合
  // 因为最后一点移动用了CSS的过渡效果
  const duration2 = 500

  export default {
    name: 'Rollbox',
    props: {
      offText: String,
    },
    data() {
      return {
        numbers: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
        delt: delt.slice(0), // 每次平移距离(%)
        distance: [0, 0], // 总平移距离(%)
        intervalIds1: [null, null],
        intervalIds2: [null, null],
      }
    },
    methods: {
      start() {
        this.resetReel()
        return new Promise(resolve => {
          this._startReel(0)
          this._startReel(1)
          this.$emit('startReel')
          resolve()
        })
      },
      stop(num) {
        return new Promise((resolve, reject) => {
          this._stopReel(1, num % 10)
            .then(() => this._stopReel(0, parseInt(num / 10)))
            .then(() => {
              this.$emit('stopReel')
              resolve()
            })
        })
      },
      // 未 roll 直接显示
      setPosition(num) {
        this._setReel(1, num % 10)
        this._setReel(0, parseInt(num / 10))
      },
      // roll 途中突然停止
      // 直接显示结果 or 错误则恢复初始状态
      abortRollAbruptly(num) {
        this._stopReel(1, num % 10, true)
        this._stopReel(0, parseInt(num / 10), true)
        this.$emit('stopReel')
      },
      // 卷轴开始转动
      _startReel(eleIndex) {
        let el = this.$refs[`reel${eleIndex}`][0]
        let that = this
        let base = 20
        el.classList.remove('braking')
        this.distance[eleIndex] = -(Math.random() * base) // 初始位置：错开一定的位置
        this.elTransformStyle(el, this.distance[eleIndex])
        function renderTop() {
          that.elTransformStyle(el, that.distance[eleIndex] % 50)
          that.distance[eleIndex] += that.delt[eleIndex]
        }
        this.intervalIds1[eleIndex] = window.setInterval(renderTop, 16.7)
      },
      // 卷轴停止
      // @params {Number} eleIndex 卷轴的索引
      // @params {Number|undefined} num 当前数字 0-9 or NaN
      // @params {Boolean} abrupt 是否突然停止
      _stopReel(eleIndex, num, abrupt = false) {
        return new Promise(resolve => {
          let el = this.$refs[`reel${eleIndex}`][0]
          this.intervalIds2[eleIndex] = window.setInterval(() => {
            this.delt[eleIndex] += 0.4
            if (this.delt[eleIndex] >= -0.2) {
              this.delt[eleIndex] = -0.2
              let current = this.distance[eleIndex] % 50 // 当前位置
              let index = this.numbers.findIndex(e => e === num) || 0
              let distance = -deltPercent * index // 最终位置
              if (!abrupt) {
                let reminder = current - distance // 彼时差距
                // 1. 绝对差距小于单次滚动距离
                if (Math.abs(reminder) <= deltPercent) {
                  // 2. 正差距或负差距但最终位置为0
                  if (reminder >= 0 || (reminder < 0 && distance === 0)) {
                    this.resetTimer(eleIndex)
                    // NOTE 下面是滚动的 hack 方式
                    if ([0, -5].includes(distance)) distance -= 50
                    el.classList.add('braking')
                    this.elTransformStyle(el, distance)
                    setTimeout(() => {
                      resolve()
                    }, duration2)
                  }
                }
              } else {
                // 直接停止
                this.resetTimer(eleIndex)
                this.elTransformStyle(el, isNaN(num) ? current : distance)
                resolve()
              }
            }
          }, duration1)
        })
      },
      // 设置卷轴位置
      _setReel(eleIndex, num) {
        let el = this.$refs[`reel${eleIndex}`][0]
        let index = this.numbers.findIndex(e => e === num)
        let distance = -deltPercent * index // 最终位置
        this.elTransformStyle(el, distance)
      },
      // 修改 el 的 translateY 的值
      elTransformStyle(el, dis) {
        el.style.transform = `translateY(${dis}%)`
        el.style['-webkit-transform'] = `translateY(${dis}%)`
      },
      // 重置操作 1
      resetReel() {
        this.delt = delt.slice(0)
        this.distance = [0, 0]
      },
      // 重置操作 2
      resetTimer(eleIndex) {
        window.clearInterval(this.intervalIds1[eleIndex])
        window.clearInterval(this.intervalIds2[eleIndex])
        this.intervalIds1[eleIndex] = null
        this.intervalIds2[eleIndex] = null
      },
    },
  }
</script>
<style lang="scss" scoped>
  .rollbox-component {
    .rollbox-line {
      @include px2res(padding-top, 4);
      @include flexrc;
      align-items: flex-end;
    }
    .rollbox-number {
      @include flexrc;
      .number-list-wrapper {
        position: relative;
        overflow: hidden;
        @include px2res(height, 80);
        @include px2res(width, 60);
        @include px2res(margin-left, -10);
        @include px2res(margin-right, -4);
        .braking.number-list {
          transition: all ease-out 0.5s;
        }
      }
    }
    .number-item,
    .rollbox-percent,
    .rollbox-off {
      font-family: $teko-font-family;
      color: #fff07b;
      text-align: center;
      @include px2res(
        text-shadow,
        4,
        0,
        10,
        'rgba(255, 78, 0, 0.65),',
        -4,
        0,
        10,
        'rgba(255, 78, 0, 0.65),',
        0,
        4,
        10,
        'rgba(255, 78, 0, 0.65),',
        0,
        -4,
        10,
        'rgba(255, 78, 0, 0.65)'
      );
    }
    .number-item {
      line-height: 0.95;
      @include px2res(font-size, 100);
    }
    .rollbox-percent {
      @include px2res(margin, 0, 0, -12, 2);
      @include px2res(font-size, 80);
      font-family: $teko-font-family !important;
    }
    .rollbox-off {
      @include px2res(margin-top, 4);
      @include px2res(font-size, 60);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/rollbox/rollbox.vue